import type { FC, PropsWithChildren } from 'react';

import LogoIcon from '../assets/icons/logo.svg?url';

export const ClientAuthLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex min-h-dvh w-full flex-col bg-[#F1F7FA]">
      <div className="flex w-full items-center justify-center bg-white pb-2 pt-[24px]">
        <img
          alt="header logo"
          className="h-[28px] object-cover"
          src={LogoIcon}
        />
      </div>
      <div className="flex flex-1 flex-col px-[16px] pb-[76px] pt-4">
        {children}
      </div>
    </div>
  );
};
